{
	"account": "Compte",
	"accountPlaceholder": "Sélectionner un compte",
	"attachment": "Pièce jointe",
	"billAttachmentSize": "Fichier trop volumineux (max 20 MB)",
	"billType": "Type",
	"billtypePlaceholder": "Sélectionner un type",
	"costCenter": "Centre de coûts",
	"costCenterPlaceholder": "Sélectionner un centre de coûts",
	"deleteBill": "Êtes-vous sûr de vouloir supprimer ce compte ?",
	"description": "Description",
	"descriptionPlaceholder": "Saisir une description",
	"dueDate": "Date d'échéance",
	"invalidValue": "Valeur non valide",
	"loading": "Chargement...",
	"observation": "Commentaire",
	"payDate": "Jour de paiement",
	"paymentMethod": "Moyen de paiement",
	"paymentMethodPlaceholder": "Sélectionner un moyen de paiement",
	"paymentMethods": {
		"app": "App",
		"automaticDebit": "Débit automatique",
		"bankTransfer": "Virement bancaire",
		"boleto": "Relevé bancaire",
		"check": "Chèque",
		"creditCard": "Carte de crédit",
		"debitCard": "Carte de débit",
		"money": "Espèces",
		"promissory": "Promesse de vente"
	},
	"performDate": "Date d'exécution",
	"reconciled": "Reconcilié",
	"status": "Payé",
	"supplier": "Fournisseur",
	"supplierPlaceholder": "Sélectionner un fournisseur",
	"toPay": "À Payer",
	"toReceive": "À recevoir",
	"validateField": "Champ obligatoire",
	"value": "Montant"
}
